export const ORDER_TOTAL_AMOUNT = 'ORDER_TOTAL_AMOUNT'
